module.exports = __webpack_public_path__ + "BradescoSans-Light.866895e0d3d0a2c0c5c7.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Light.woff2
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Light.woff2
// module chunks = main